import { useQuery } from '@tanstack/react-query';
import React, { ReactNode } from 'react';
import req from 'utils/req';

type MenuItemDecoratorProps = {
  link: any;
  children: ReactNode;
};

const getNewMessagesCount = async () =>
  req(`${URL_API_HOST}/api/v1/messages/new`).get();

function NewMessagesDecorator({ children }: { children: any }) {
  const { data: unreadMessages } = useQuery({
    queryKey: ['new-messages'],
    queryFn: getNewMessagesCount,
    refetchOnMount: false,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  return (
    <>{React.cloneElement(children, { badgeNumber: unreadMessages?.unread })}</>
  );
}

function MenuItemDecorator({ link, children }: MenuItemDecoratorProps) {
  if (link === '/messages/') {
    return <NewMessagesDecorator>{children}</NewMessagesDecorator>;
  }
  return <>{children}</>;
}

export default MenuItemDecorator;
